import {HalfImageLayout} from '@cypro/ui/components/layout/half-image-layout'
import {Box, Flex, Image} from '@chakra-ui/react'
import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {useGetPublicSettings} from '@/modules/settings/api'

export const Route = createFileRoute('/auth')({
  component: AuthLayout,
})

function AuthLayout() {
  const {t} = useTranslate('auth')
  const location = useLocation()
  const isSetupPassword = location.pathname.includes('password-setup')
  const {settings} = useGetPublicSettings()

  return (
    <Box padding="1" background="bg.muted" width="100%" height="100dvh">
      <HalfImageLayout
        image={
          isSetupPassword
            ? undefined
            : {
                src: '/static/login-hero.webp',
                role: 'presentation',
                sizes: '50vw',
                fetchPriority: 'high',
                loading: 'eager',
                caption: t('marketing_caption'),
                customCaption: settings?.loginText,
                logoUrl: settings?.logoUrl,
              }
        }
      >
        <Image
          src="/static/login-background.webp"
          alt="Background"
          role="presentation"
          position="absolute"
          top="0"
          left="0"
          pointerEvents="none"
          zIndex="1"
          width="100vw"
          height="auto"
          hideBelow={'md'}
        />

        <Flex flexDirection="column" justifyContent="space-between" height="100%" position="relative" zIndex="5">
          <Outlet />
        </Flex>
      </HalfImageLayout>
    </Box>
  )
}
